import { render, staticRenderFns } from "./DepositScenarioSimulator.vue?vue&type=template&id=03566338"
import script from "./DepositScenarioSimulator.vue?vue&type=script&lang=js"
export * from "./DepositScenarioSimulator.vue?vue&type=script&lang=js"
import style0 from "./DepositScenarioSimulator.vue?vue&type=style&index=0&id=03566338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports